import config from '../../../config/config';

export const verifyEmail = (email, voucherCode) => {
    return new Promise((resolve, reject) => {
        fetch(`${config.backend_domain}:${config.backend_port}/trial-vouchers/send-activation-email`, {
            method: "POST",
            body: JSON.stringify({ Email: email, VoucherCode: voucherCode }),
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(response => {
            return response.json();
        }).then(response => {
            if (response.status !== 200) {
                resolve({ status: false, message: response.message });
            } else {
                resolve({ status: true, message: response.message });
            }
        }).catch(error => {
            resolve(null);
        }).catch(error => {
            resolve({ status: false, message: 'Error durring email verification. Please contact administrator.' });
        });
    });
}

export const registerUser = params => {
    return new Promise((resolve, reject) => {
        fetch(`${config.backend_domain}:${config.backend_port}/trial-vouchers/register`, {
            method: "POST",
            body: params,

        }).then(response => {
            return response.json();
        }).then(response => {
            if (response.status !== 200) {
                resolve({ status: false, message: response.message, errorKey: response.errorKey });
            } else {
                resolve({ status: true, message: response.message });
            }
        }).catch(error => {
            resolve({ status: false, error: true, message: 'Error durring registration. Please contact administrator.' });
        });
    });
}